<div id="acc-root" class="acc-overlay" (click)="closeModal()">
  <section
    class="acc-card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="acc-title"
    (click)="$event.stopPropagation()"
  >
    <h2 id="acc-title">{{ 'components.accountModal.title' | translate }}</h2>

    <form class="acc-form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Nom -->
      <div class="acc-field">
        <label for="acc-last">{{ 'components.accountModal.fields.lastName' | translate }}</label>
        <input id="acc-last" class="acc-input" type="text" formControlName="lastName" />
      </div>

      <!-- Prénom -->
      <div class="acc-field">
        <label for="acc-first">{{ 'components.accountModal.fields.firstName' | translate }}</label>
        <input id="acc-first" class="acc-input" type="text" formControlName="firstName" />
      </div>

      <!-- Email (lecture seule) -->
      <div class="acc-field">
        <label for="acc-mail">{{ 'components.accountModal.fields.email' | translate }}</label>
        <input
          id="acc-mail"
          class="acc-input acc-input--soft"
          type="email"
          formControlName="email"
          readonly
        />
      </div>

      <!-- Langue de l'interface -->
      <div class="acc-field">
        <label>{{ 'components.accountModal.fields.language' | translate }}</label>
        <app-language-select formControlName="locale" [ariaLabel]="'components.accountModal.fields.language' | translate"></app-language-select>
      </div>

      <!-- Nouveau mot de passe (optionnel) -->
      <div class="acc-field">
        <label for="acc-pass">{{ 'components.accountModal.fields.newPassword' | translate }}</label>
        <input
          id="acc-pass"
          class="acc-input"
          type="password"
          formControlName="newPassword"
          autocomplete="new-password"
          placeholder="********"
        />
        <!-- checklist des règles (live) -->
        <ul class="acc-rules" *ngIf="!pwRules.empty">
          <li [class.ok]="pwRules.len"     [class.ko]="!pwRules.len">{{ 'components.accountModal.passwordRules.length' | translate }}</li>
          <li [class.ok]="pwRules.lower"   [class.ko]="!pwRules.lower">{{ 'components.accountModal.passwordRules.lowercase' | translate }}</li>
          <li [class.ok]="pwRules.upper"   [class.ko]="!pwRules.upper">{{ 'components.accountModal.passwordRules.uppercase' | translate }}</li>
          <li [class.ok]="pwRules.digit"   [class.ko]="!pwRules.digit">{{ 'components.accountModal.passwordRules.digit' | translate }}</li>
          <li [class.ok]="pwRules.special" [class.ko]="!pwRules.special">{{ 'components.accountModal.passwordRules.special' | translate }}</li>
          <li [class.ok]="pwRules.spaces"  [class.ko]="!pwRules.spaces">{{ 'components.accountModal.passwordRules.noSpaces' | translate }}</li>
        </ul>
      </div>

      <!-- Confirmation mot de passe -->
      <div class="acc-field" *ngIf="pwValue.trim().length > 0">
        <label for="acc-confirm">{{ 'components.accountModal.fields.confirmPassword' | translate }}</label>
        <input
          id="acc-confirm"
          class="acc-input"
          type="password"
          formControlName="confirmPassword"
          autocomplete="new-password"
          [placeholder]="'components.accountModal.confirmPasswordPlaceholder' | translate"
        />
        <div *ngIf="form.hasError('passwordMismatch') && form.get('confirmPassword')?.value" class="acc-msg acc-msg--error">
          {{ 'components.accountModal.passwordMismatch' | translate }}
        </div>
        <div *ngIf="!form.hasError('passwordMismatch') && form.get('confirmPassword')?.value && pwValue.trim().length > 0" class="acc-msg acc-msg--ok">
          {{ 'components.accountModal.passwordMatch' | translate }}
        </div>
      </div>

      <!-- Messages -->
      <div *ngIf="errorMsg" class="acc-msg acc-msg--error">{{ errorMsg }}</div>
      <div *ngIf="okMsg" class="acc-msg acc-msg--ok">{{ okMsg }}</div>

      <!-- Actions -->
      <div class="acc-actions">
        <button type="button" class="acc-btn acc-cancel" [disabled]="loading" (click)="closeModal()">
          {{ 'components.accountModal.actions.cancel' | translate }}
        </button>
        <button class="acc-primary" type="submit" [disabled]="loading || form.invalid">
          {{ loading ? '...' : ('components.accountModal.actions.save' | translate) }}
        </button>
      </div>
    </form>
  </section>
</div>
